import { render } from "./index.vue?vue&type=template&id=2ec43197&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2ec43197&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-2ec43197"

export default script